import { render, staticRenderFns } from "./DashboardUnrepliedConversations.vue?vue&type=template&id=e5d3a050&scoped=true&lang=pug"
import script from "./DashboardUnrepliedConversations.vue?vue&type=script&lang=js"
export * from "./DashboardUnrepliedConversations.vue?vue&type=script&lang=js"
import style0 from "./DashboardUnrepliedConversations.vue?vue&type=style&index=0&id=e5d3a050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d3a050",
  null
  
)

export default component.exports